<script>
import Layout from "@/router/layouts/auth";
import { api } from "@/state/services";
import { mapState, mapActions } from "vuex";

export default {
  locales: {
    pt: {
    },
    es: {
    },
  },
  components: {
    Layout,
  },
  data() {
    return {
      step: 1,

      search: {
        loading: false,
        type: "",
        name: "",
        personNumberMask: "###.###.###-##",
        personNumber: "",
      },

      user: {
        loading: false,

        type: "",
        name: "",
        personNumber: "",

        email: "",
        cellphone: "",

        zipcode: "",
        address: "",
        number: "",
        complement: "",
        district: "",
        city: "",
        state: "",

        password: "",
      },
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
  },
  methods: {
    ...mapActions("account", [ "token"]),
    selectType(v) {
      this.search.type = v;
      this.search.name = "";
      this.search.personNumber = "";
      this.step = 2;
    },
    changeType() {
      this.search.type = "";
      this.search.name = "";
      this.search.personNumber = "";
      this.step = 1;
    },
    checkUser() {
      if (this.search.type && this.search.personNumber) {
        this.search.loading = true;

        api
          .post("user/first/check", {
            type: this.search.type,
            name: this.search.name,
            personNumber: this.search.personNumber,
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.user.type = this.search.type;

              if (this.search.type == 'regional') {
                this.user.name = response.data.user.name;
              } else {
                this.user.name = this.search.name;
              }

              this.user.personNumber = this.search.personNumber;

              if (response.data.user.email) {
                this.user.email = response.data.user.email;
              }

              this.step = 3;
              this.search.loading = false;
            } else {
              this.$toast.error(response.data.message);
              this.search.loading = false;
            }
          });
      }
    },
    updateUser() {
      if (this.search.type && this.search.personNumber) {
        this.user.loading = true;

        api
          .post("user/first/update", {
            type: this.search.type,
            name: this.user.name,
            personNumber: this.user.personNumber,
            email: this.user.email,
            cellphone: this.user.cellphone,
            zipcode: this.user.zipcode,
            address: this.user.address,
            number: this.user.number,
            complement: this.user.complement,
            district: this.user.district,
            city: this.user.city,
            state: this.user.state,
            password: this.user.password,
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.step = 4;
              this.user.loading = false;

              this.$toast.success(response.data.message);
              const key = response.data.token;
              this.token({ key });
            } else {
              this.$toast.error(response.data.message);
              this.user.loading = false;
            }
          });
      }
    },
    searchCep() {
      if (this.user.zipcode.length == 9) {
        api.get("https://cep.m2n.com.br/" + this.user.zipcode.replace(/\D/g, "")).then((response) => {
          if (response.data.city == "") {
            this.alert.type = "alert-danger";
            this.alert.message = "O CEP informado é inválido.";
          } else {
            this.alert.type = "";
            this.alert.message = "";

            if (response.data.address) {
              this.user.address = response.data.address;
            }
            if (response.data.district) {
              this.user.district = response.data.district;
            }
            this.user.city = response.data.city;
            this.user.state = response.data.state;
          }
        });
      }
    },
  },
  mounted() {
  },
  watch: {
    'search.personNumber'(value) {
      if (value.length <= 14) {
        this.search.personNumberMask = '###.###.###-##';
      } else {
        this.search.personNumberMask = '##.###.###/####-##';
      }
    }
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 text-center">
          <router-link class="align-middle" tag="a" to="/">
            <img class="w-100" style="max-width: 250px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-5">
          <h4 class="mb-3 text-center">Primeiro acesso</h4>
          <b-progress :value="step" max="4" class="mb-5" variant="default"></b-progress>

          <template v-if="step == 1">
            <div class="text-center mb-3">Selecione o seu tipo de acesso</div>
            <button class="btn btn-outline-default btn-lg btn-block notranslate" translate="no" v-on:click="selectType('regional')">Regional</button>
            <div class="text-center py-1">ou</div>
            <button class="btn btn-outline-default btn-lg btn-block notranslate" translate="no" v-on:click="selectType('consultor');">Consultor</button>
          </template>
          <template v-else-if="step == 2">
            <template v-if="search.type == 'regional'">
              <h5 class="mb-1">Acesso de Regional</h5>
              <div class="mb-4">O seu CNPJ deve ser o mesmo que está cadastrado no sistema da APVS.</div>
              <b-form-group label="CNPJ" label-for="search.personNumber">
                <b-form-input v-model="search.personNumber" type="text" inputmode="numeric" v-mask="'##.###.###/####-##'"></b-form-input>
              </b-form-group>
            </template>
            <template v-else-if="search.type == 'consultor'">
              <h5 class="mb-1">Acesso de Consultor</h5>
              <div class="mb-4">O seu nome e CPF/CNPJ deve ser o mesmo que está cadastrado no sistema da APVS.</div>
              <b-form-group label="Nome" label-for="search.name">
                <b-form-input v-model="search.name" type="text"></b-form-input>
              </b-form-group>
              <b-form-group label="CPF/CNPJ" label-for="search.personNumber">
                <b-form-input v-model="search.personNumber" type="text" inputmode="numeric" v-mask="search.personNumberMask"></b-form-input>
              </b-form-group>
            </template>
            <button class="btn btn-default btn-lg btn-block notranslate" translate="no" v-on:click="checkUser();">
              Avançar
              <b-spinner v-if="search.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
            </button>
            <button class="btn btn-outline-default btn-lg btn-block notranslate" translate="no" v-on:click="changeType();">Voltar</button>
          </template>
          <template v-else-if="step == 3">
            <h5 class="mb-1">Dados do usuário</h5>
            <div class="mb-4">Verifique se os dados estão corretos e complete o seu cadastro</div>
            <b-form-group label="Nome" label-for="user.name">
              <b-form-input class="bg-soft-dark" v-model="user.name" type="text" disabled></b-form-input>
            </b-form-group>
            <b-form-group label="CPF/CNPJ" label-for="user.personNumber">
              <b-form-input class="bg-soft-dark" v-model="user.personNumber" type="text" inputmode="numeric" v-mask="search.personNumberMask" disabled></b-form-input>
            </b-form-group>

            <b-form-group label="Email" label-for="user.email">
              <b-form-input v-model="user.email" type="email"></b-form-input>
            </b-form-group>
            <b-form-group label="Celular" label-for="user.cellphone">
              <b-form-input v-model="user.cellphone" type="text" inputmode="numeric" v-mask="'(##) #####-####'"></b-form-input>
            </b-form-group>

            <div class="divisor mb-3">
              <span>Endereço</span>
            </div>

            <b-form-group label="CEP" label-for="user.zipcode">
              <b-form-input v-on:blur="searchCep()" v-model="user.zipcode" type="text" inputmode="numeric" autocomplete="off" v-mask="'#####-###'"></b-form-input>
            </b-form-group>
            <b-form-group label="Endereço" label-for="user.address">
              <b-form-input v-model="user.address" type="text" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group label="Número" label-for="user.number">
              <b-form-input v-model="user.number" type="text" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group label="Complemento" label-for="user.complement">
              <b-form-input v-model="user.complement" type="text" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group label="Bairro" label-for="user.district">
              <b-form-input v-model="user.district" type="text" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group label="Cidade" label-for="user.city">
              <b-form-input class="bg-soft-info" v-model="user.city" type="text" autocomplete="off" readonly="readonly"></b-form-input>
            </b-form-group>
            <b-form-group label="Estado" label-for="user.state">
              <b-form-input class="bg-soft-info" v-model="user.state" type="text" autocomplete="off" readonly="readonly" v-mask="'XX'"></b-form-input>
            </b-form-group>

            <div class="divisor mb-3">
              <span>Crie uma senha de acesso</span>
            </div>
            <b-form-group label="Senha" label-for="user.password">
              <b-form-input v-model="user.password" type="text" autocomplete="off"></b-form-input>
            </b-form-group>

            <button class="btn btn-default btn-lg btn-block mt-5" v-on:click="updateUser()">
              Salvar
              <b-spinner v-if="user.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
            </button>
            <button class="btn btn-outline-default btn-lg btn-block" v-on:click="changeType();">Voltar</button>
          </template>
          <template v-else-if="step == 4">
            <h5 class="text-center">As informações do seu cadastro foram atualizadas com sucesso!</h5>
            <router-link tag="a" to="/login" class="d-block btn btn-outline-default btn-lg btn-block mt-4">Entrar</router-link>
          </template>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.label-description {
  margin: -10px 0 10px 0;
}
.divisor {
  position: relative;
  text-align: center;
  text-transform: uppercase;
}
.divisor span {
  display: inline-block;
  padding: 0 5px;
  background: #fff;
  font-size: 10px;
  letter-spacing: 2px;
  color: #888;
}
.divisor:before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  left: 0;
  right: 0;
  top: 52%;
  height: 1px;
  background: #ccc;
}
</style>
